const DateOptions = {day: '2-digit', month: 'short', year: 'numeric'}


export { DateOptions }